function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';

var FullscreenShareButtons = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenShareButtons, _React$Component);

  function FullscreenShareButtons(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.buttons = [];
    return _this;
  }

  var _proto = FullscreenShareButtons.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    try {
      var focusedButton = this.props.focus;

      if (focusedButton > 0) {
        this.buttons[focusedButton - 1].focus();
      }
    } catch (e) {
      console.warn('Cannot focus on share icon', this.props.focus, e);
    }
  };

  _proto.createSingleShareButton = function createSingleShareButton(shareArr, network, idx) {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("li", {
      key: idx,
      role: "menuitem"
    }, /*#__PURE__*/React.createElement("button", {
      className: 'fullscreen-social-' + network + ' progallery-svg-font-icons-' + network + ' has-custom-focus',
      ref: function ref(button) {
        return _this2.buttons[idx] = button;
      },
      onClick: function onClick() {
        var shareData = {
          network: network,
          shareProps: _this2.props.item
        };

        _this2.props.actions.eventsListener(FULLSCREEN_EVENTS.SHARE_BUTTON_CLICKED, shareData);
      },
      key: network + '-share-icon',
      "data-hook": network + '-share-hook',
      title: "Share on " + network,
      tabIndex: -1
    }));
  };

  _proto.render = function render() {
    var _this3 = this;

    var shareArr = ['facebook', 'twitter', 'pinterest', 'tumblr', 'email'];

    if (this.props.item.type === 'text') {
      shareArr.splice(2, 1);
    }

    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: "fullscreen-social-items-container",
      "aria-hidden": this.props.ariaHidden !== 'undefined' ? this.props.ariaHidden : false,
      role: "menu"
    }, shareArr.map(function (network, idx) {
      return _this3.createSingleShareButton(shareArr, network, idx);
    })));
  };

  return FullscreenShareButtons;
}(React.Component);

export default FullscreenShareButtons;